(function () {
  const html = document.documentElement;
  html.classList.remove('no-js');
  html.classList.add('js');

  const navToggles = document.querySelectorAll('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const setMobileNav = function (open) {
    if (!mobileNav) return;
    mobileNav.hidden = !open;
    document.body.classList.toggle('mobile-nav-open', open);
    navToggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', String(open));
    });
    if (!open) {
      mobileNav.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (toggle) {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }
  };
  if (navToggles.length && mobileNav) {
    navToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        setMobileNav(mobileNav.hidden);
      });
    });
    mobileNav.addEventListener('click', function (event) {
      if (event.target === mobileNav) setMobileNav(false);
      const link = event.target.closest('a');
      if (link && mobileNav.contains(link)) setMobileNav(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setMobileNav(false);
    });
    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 991px)').matches) setMobileNav(false);
    });
  }

  document.querySelectorAll('[data-mega-root]').forEach(function (root) {
    const menu = root.querySelector('[data-mega-menu]');
    const toggles = root.querySelectorAll('[data-mega-toggle]');
    const closeButtons = root.querySelectorAll('[data-mega-close]');
    if (!menu || !toggles.length) return;

    const setMega = function (open) {
      root.classList.toggle('is-mega-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
      });
    };

    // Öffnet das Menü per Hover, darf der unmittelbar folgende Klick es nicht wieder schließen.
    let hoverOpenedAt = 0;
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        const isOpen = root.classList.contains('is-mega-open');
        if (isOpen && Date.now() - hoverOpenedAt < 800) return;
        setMega(!isOpen);
      });
      toggle.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches && !root.classList.contains('is-mega-open')) {
          hoverOpenedAt = Date.now();
          setMega(true);
        }
      });
    });

    root.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover: hover)').matches) setMega(false);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setMega(false);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setMega(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setMega(false);
    });
  });

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (toggle) {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    toggle.addEventListener('click', function () {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      const scope = toggle.closest('[data-mobile-nav]') || document;
      if (!open) {
        scope.querySelectorAll('[data-mobile-submenu-toggle][aria-expanded="true"]').forEach(function (otherToggle) {
          if (otherToggle === toggle) return;
          const otherPanel = document.getElementById(otherToggle.getAttribute('aria-controls'));
          otherToggle.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });
      }
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  });

  document.querySelectorAll('[data-submit-on-change]').forEach(function (element) {
    element.addEventListener('change', function () {
      const form = element.closest('form');
      if (form) form.submit();
    });
  });

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filters = document.querySelector('[data-filters]');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', function () {
      filters.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    const variantSelect = section.querySelector('[data-variant-select]');
    const priceTargets = section.querySelectorAll('[data-product-current-price], [data-mobile-sticky-price]');
    const compareTarget = section.querySelector('[data-product-price] .price__compare');
    const compareAmountTarget = section.querySelector('[data-product-compare-amount]');
    const unitPriceTarget = section.querySelector('[data-product-unit-price]');
    const lowestPriceTarget = section.querySelector('[data-product-lowest-price]');
    const savingTarget = section.querySelector('[data-product-saving]');
    const buttons = section.querySelectorAll('[data-product-button], [data-product-external-button]');
    const stock = section.querySelector('[data-product-stock]');
    const stickyStock = section.querySelector('[data-mobile-sticky-stock]');
    if (!variantSelect) return;

    variantSelect.addEventListener('change', function () {
      const option = variantSelect.selectedOptions[0];
      const available = option.dataset.available === 'true';
      if (option.dataset.price) {
        priceTargets.forEach(function (target) {
          target.textContent = option.dataset.price;
        });
      }
      if (compareTarget) {
        if (option.dataset.compare) {
          if (compareAmountTarget) {
            compareAmountTarget.textContent = option.dataset.compare;
          } else {
            compareTarget.textContent = option.dataset.compare;
          }
          compareTarget.hidden = false;
        } else {
          compareTarget.hidden = true;
        }
      }
      if (unitPriceTarget) {
        unitPriceTarget.textContent = option.dataset.unitPrice || '';
        unitPriceTarget.hidden = !option.dataset.unitPrice;
      }
      if (lowestPriceTarget) {
        lowestPriceTarget.hidden = !option.dataset.compare;
      }
      if (savingTarget) {
        if (option.dataset.saving) {
          savingTarget.textContent = option.dataset.saving;
          savingTarget.hidden = false;
        } else {
          savingTarget.hidden = true;
        }
      }
      buttons.forEach(function (button) {
        button.disabled = !available;
        button.textContent = available ? 'In den Warenkorb' : 'Nicht verfügbar';
      });
      if (stock) {
        const stockDot = stock.querySelector('.stock-dot');
        if (stockDot) {
          stockDot.textContent = available ? 'Auf Lager' : 'Nicht verfügbar';
          stockDot.classList.toggle('stock-dot--in', available);
        }
      }
      section.querySelectorAll('.product-mobile-sticky-cta, .product-mobile-heading__price').forEach(function (el) {
        el.classList.toggle('is-sale', Boolean(option.dataset.compare));
      });
      if (stickyStock) {
        stickyStock.textContent = available ? 'Auf Lager · schneller Versand' : 'Aktuell nicht verfügbar';
      }
    });
  });
})();

(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const buttons = gallery.querySelectorAll('[data-gallery-target]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const targetId = button.getAttribute('data-gallery-target');
        const target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        buttons.forEach(function (otherButton) {
          otherButton.classList.toggle('is-active', otherButton === button);
          otherButton.setAttribute('aria-current', otherButton === button ? 'true' : 'false');
        });

        gallery.querySelectorAll('.product-gallery__item').forEach(function (item) {
          const isActive = item === target;
          item.classList.toggle('is-active', isActive);
          item.hidden = !isActive;
        });
      });
    });
  });

  const isWeekend = function (date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  // Bundesweite Feiertage + frei konfigurierbare Schließtage (Theme-Editor, Block „Versandversprechen“).
  const holidayCache = {};
  const easterSunday = function (year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day, 12, 0, 0, 0);
  };
  const dayKey = function (date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  };
  const germanHolidays = function (year) {
    if (holidayCache[year]) return holidayCache[year];
    const easter = easterSunday(year);
    const shift = function (days) {
      const d = new Date(easter.getTime());
      d.setDate(d.getDate() + days);
      return d;
    };
    const list = [
      new Date(year, 0, 1), shift(-2), shift(1), new Date(year, 4, 1), shift(39), shift(50),
      new Date(year, 9, 3), new Date(year, 11, 25), new Date(year, 11, 26)
    ];
    holidayCache[year] = list.reduce(function (acc, d) { acc[dayKey(d)] = true; return acc; }, {});
    return holidayCache[year];
  };
  const parseClosedDays = function (text) {
    // Erlaubt z. B. "24.12., 31.12." (jedes Jahr) oder "27.12.2026" (einmalig), getrennt durch Komma, Semikolon oder Zeilenumbruch.
    return String(text || '').split(/[,;\n]+/).map(function (part) {
      const match = part.trim().match(/^(\d{1,2})\.(\d{1,2})\.?(\d{4})?$/);
      if (!match) return null;
      return { day: parseInt(match[1], 10), month: parseInt(match[2], 10), year: match[3] ? parseInt(match[3], 10) : null };
    }).filter(Boolean);
  };
  let closedDays = [];
  const isNonWorkingDay = function (date) {
    if (isWeekend(date)) return true;
    if (germanHolidays(date.getFullYear())[dayKey(date)]) return true;
    return closedDays.some(function (c) {
      return c.day === date.getDate() && c.month === date.getMonth() + 1 && (!c.year || c.year === date.getFullYear());
    });
  };

  const addBusinessDays = function (date, days) {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (!isNonWorkingDay(result)) added += 1;
    }
    return result;
  };

  const nextBusinessDay = function (date) {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
    do {
      result.setDate(result.getDate() + 1);
    } while (isNonWorkingDay(result));
    return result;
  };

  const formatDeliveryDate = function (date) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit'
    }).format(date);
  };

  const getZonedNow = function (timeZone) {
    if (!timeZone) return new Date();
    try {
      const parts = new Intl.DateTimeFormat('de-DE', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).formatToParts(new Date()).reduce(function (acc, part) {
        if (part.type !== 'literal') acc[part.type] = parseInt(part.value, 10);
        return acc;
      }, {});
      const hour = parts.hour === 24 ? 0 : parts.hour;
      return new Date(parts.year, parts.month - 1, parts.day, hour, parts.minute || 0, parts.second || 0, 0);
    } catch (error) {
      return new Date();
    }
  };

  const padHour = function (hour) {
    return String(Math.max(0, Math.min(23, hour))).padStart(2, '0') + ':00 Uhr';
  };

  const formatRemaining = function (milliseconds) {
    const totalMinutes = Math.max(0, Math.floor(milliseconds / 60000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const parts = [];
    if (hours > 0) parts.push(hours + ' Std.');
    if (minutes > 0 || hours === 0) parts.push(minutes + ' Min.');
    return parts.join(' ');
  };

  const replaceDeliveryTokens = function (text, tokens) {
    return String(text || '').replace(/\[\[(cutoff|start|time)\]\]/g, function (_, key) {
      return tokens[key] || '';
    });
  };

  const updateDeliveryPromise = function (element) {
    const minDays = Math.max(1, parseInt(element.dataset.minDays || '1', 10));
    const maxDays = Math.max(minDays, parseInt(element.dataset.maxDays || String(minDays), 10));
    const cutoffHour = parseInt(element.dataset.cutoffHour || '18', 10);
    const countdownStartHour = parseInt(element.dataset.countdownStartHour || '12', 10);
    const sameDayEnabled = element.dataset.sameDayEnabled !== 'false';
    const now = getZonedNow(element.dataset.timeZone || 'Europe/Berlin');
    const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
    const countdownStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), countdownStartHour, 0, 0, 0);
    closedDays = parseClosedDays(element.dataset.closedDays);
    const isBusinessDay = !isNonWorkingDay(now);
    const beforeCutoff = isBusinessDay && now < cutoff;
    const countdownLive = sameDayEnabled && beforeCutoff && now >= countdownStart;
    const beforeCountdown = sameDayEnabled && beforeCutoff && now < countdownStart;
    const processingBase = beforeCutoff ? now : nextBusinessDay(now);
    const minDate = addBusinessDays(processingBase, minDays);
    const maxDate = addBusinessDays(processingBase, maxDays);
    const windowTarget = element.querySelector('[data-delivery-window]');
    const cutoffTarget = element.querySelector('[data-delivery-cutoff]');
    const cutoffWrap = element.querySelector('[data-delivery-message]');
    const statusTarget = element.querySelector('[data-delivery-status]');
    const pillTarget = element.querySelector('[data-delivery-pill]');
    const tokens = {
      cutoff: padHour(cutoffHour),
      start: padHour(countdownStartHour),
      time: formatRemaining(cutoff - now)
    };

    element.classList.toggle('delivery-promise--countdown-live', countdownLive);
    element.classList.toggle('delivery-promise--before-countdown', beforeCountdown);
    element.classList.toggle('delivery-promise--cutoff-passed', sameDayEnabled && (!isBusinessDay || (isBusinessDay && !beforeCutoff)));

    if (windowTarget) {
      windowTarget.textContent = formatDeliveryDate(minDate) + ' – ' + formatDeliveryDate(maxDate);
    }

    if (statusTarget) {
      const statusText = beforeCutoff
        ? (element.dataset.sameDayLabel || 'Taggleicher Versand bis [[cutoff]]')
        : (element.dataset.nextdayLabel || 'Versand am nächsten Werktag');
      statusTarget.textContent = replaceDeliveryTokens(statusText, tokens);
    }

    if (pillTarget) {
      if (countdownLive) {
        pillTarget.textContent = 'Heute möglich';
      } else if (beforeCutoff) {
        pillTarget.textContent = 'Heute möglich';
      } else {
        pillTarget.textContent = 'Nächster Versandtag';
      }
    }

    if (cutoffTarget) {
      if (cutoffWrap) cutoffWrap.hidden = false;
      if (sameDayEnabled && countdownLive) {
        cutoffTarget.textContent = replaceDeliveryTokens(element.dataset.liveCountdownText || 'Noch [[time]] – Versand heute.', tokens);
      } else if (sameDayEnabled && beforeCountdown) {
        cutoffTarget.textContent = replaceDeliveryTokens(element.dataset.beforeCountdownText || 'Bei Bestellung bis [[cutoff]] versenden wir heute.', tokens);
      } else if (sameDayEnabled && (!isBusinessDay || !beforeCutoff)) {
        cutoffTarget.textContent = '';
        if (cutoffWrap) cutoffWrap.hidden = true;
      } else if (beforeCutoff) {
        cutoffTarget.textContent = 'Bestelle innerhalb von ' + formatRemaining(cutoff - now) + ' für schnellstmöglichen Versand.';
      } else {
        cutoffTarget.textContent = '';
        if (cutoffWrap) cutoffWrap.hidden = true;
      }
    }
  };

  document.querySelectorAll('[data-delivery-promise]').forEach(function (element) {
    if (element.classList.contains('delivery-promise--inactive')) return;
    updateDeliveryPromise(element);
    window.setInterval(function () {
      updateDeliveryPromise(element);
    }, 60000);
  });
})();


// SortimentPlus: bestandsabhängige Mengensteuerung für Produktseite + Mobile Sticky CTA.
// DIESEN BLOCK anstelle des bisherigen v1.17-Quantity-Stepper-Blocks einsetzen.
(function () {
  'use strict';

  function toInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function smallest(values) {
    var filtered = values.filter(function (value) {
      return typeof value === 'number' && Number.isFinite(value);
    });
    return filtered.length ? Math.min.apply(Math, filtered) : null;
  }

  function alignMaximum(maximum, minimum, increment) {
    if (maximum === null) return null;
    if (maximum < minimum) return 0;
    return minimum + Math.floor((maximum - minimum) / increment) * increment;
  }

  function normalizeQuantity(value, limits) {
    if (limits.maximum === 0) return 0;

    var quantity = toInteger(value, limits.minimum);
    quantity = Math.max(limits.minimum, quantity);

    var steps = Math.round((quantity - limits.minimum) / limits.increment);
    quantity = limits.minimum + Math.max(0, steps) * limits.increment;

    if (limits.maximum !== null) {
      quantity = Math.min(quantity, limits.maximum);
    }

    return quantity;
  }

  function initProductQuantityLimit(section) {
    var dataElement = section.querySelector('[data-product-inventory-data]');
    if (!dataElement) return;

    var inventoryData;
    try {
      inventoryData = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('SortimentPlus: Bestandsdaten konnten nicht gelesen werden.', error);
      return;
    }

    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantSelect = section.querySelector('[data-variant-select]');
    var hiddenVariantInput = form.querySelector('input[name="id"]');
    var sourceQuantity = form.querySelector('input[name="quantity"]');
    var sticky = section.querySelector('[data-product-mobile-sticky]');
    var mainButton = section.querySelector('[data-product-button]');
    var paymentButton = form.querySelector('.shopify-payment-button');

    if (!sourceQuantity) {
      sourceQuantity = document.createElement('input');
      sourceQuantity.type = 'hidden';
      sourceQuantity.name = 'quantity';
      sourceQuantity.value = '1';
      form.appendChild(sourceQuantity);
    }

    var quantityInputs = Array.prototype.slice.call(
      section.querySelectorAll('[data-quantity-input], [data-mobile-sticky-quantity]')
    );
    if (quantityInputs.indexOf(sourceQuantity) === -1) {
      quantityInputs.unshift(sourceQuantity);
    }

    var quantityMessage = section.querySelector('[data-quantity-message]');
    if (!quantityMessage) {
      quantityMessage = document.createElement('p');
      quantityMessage.className = 'product-quantity-message';
      quantityMessage.setAttribute('data-quantity-message', '');
      quantityMessage.setAttribute('role', 'status');
      quantityMessage.setAttribute('aria-live', 'polite');
      quantityMessage.hidden = true;

      var quantityRow = form.querySelector('.quantity-row--stepper');
      if (quantityRow) {
        quantityRow.insertAdjacentElement('afterend', quantityMessage);
      } else {
        form.insertBefore(quantityMessage, form.querySelector('[data-product-button]'));
      }
    }

    function selectedVariantId() {
      if (variantSelect && variantSelect.value) return String(variantSelect.value);
      if (hiddenVariantInput && hiddenVariantInput.value) return String(hiddenVariantInput.value);
      return String(inventoryData.selectedVariantId || '');
    }

    function currentVariantData() {
      return inventoryData.variants[selectedVariantId()] || null;
    }

    function limitsForVariant(variant) {
      if (!variant) {
        return {
          minimum: 1,
          maximum: 0,
          increment: 1,
          remainingInventory: 0,
          available: false,
          inventoryLimited: true
        };
      }

      var minimum = Math.max(1, toInteger(variant.min, 1));
      var increment = Math.max(1, toInteger(variant.increment, 1));
      var cartQuantity = Math.max(0, toInteger(variant.cartQuantity, 0));
      var candidates = [];
      var remainingInventory = null;

      if (variant.inventoryLimited) {
        remainingInventory = Math.max(0, toInteger(variant.inventoryQuantity, 0) - cartQuantity);
        candidates.push(remainingInventory);
      }

      if (variant.max !== null && variant.max !== undefined) {
        candidates.push(Math.max(0, toInteger(variant.max, 0) - cartQuantity));
      }

      var maximum = alignMaximum(smallest(candidates), minimum, increment);

      return {
        minimum: minimum,
        maximum: maximum,
        increment: increment,
        remainingInventory: remainingInventory,
        available: variant.available === true,
        inventoryLimited: variant.inventoryLimited === true,
        cartQuantity: cartQuantity
      };
    }

    function setMessage(limits) {
      if (!quantityMessage) return;

      var text = '';
      var tone = 'neutral';

      if (!limits.available) {
        text = 'Diese Variante ist aktuell nicht verfügbar.';
        tone = 'error';
      } else if (limits.maximum === 0) {
        text = limits.cartQuantity > 0
          ? 'Die maximal verfügbare Menge befindet sich bereits im Warenkorb.'
          : 'Diese Variante ist aktuell nicht in ausreichender Menge verfügbar.';
        tone = 'warning';
      } else if (limits.inventoryLimited && limits.remainingInventory !== null && limits.remainingInventory <= 5) {
        text = limits.remainingInventory === 1
          ? 'Nur noch 1 Stück verfügbar.'
          : 'Nur noch ' + limits.remainingInventory + ' Stück verfügbar.';
        tone = 'warning';
      } else if (limits.maximum !== null) {
        text = 'Maximal ' + limits.maximum + ' Stück zusätzlich bestellbar.';
      }

      quantityMessage.textContent = text;
      quantityMessage.hidden = text === '';
      quantityMessage.dataset.tone = tone;
    }

    function currentQuantity(limits) {
      return normalizeQuantity(sourceQuantity.value || limits.minimum, limits);
    }

    function updateButtons(quantity, limits) {
      section.querySelectorAll('[data-quantity-step="-1"]').forEach(function (button) {
        button.disabled = limits.maximum === 0 || quantity <= limits.minimum;
      });

      section.querySelectorAll('[data-quantity-step="1"]').forEach(function (button) {
        button.disabled = limits.maximum === 0 || (
          limits.maximum !== null && quantity >= limits.maximum
        );
      });
    }

    function updatePurchasingState(limits) {
      var canAdd = limits.available && limits.maximum !== 0;
      var buttons = section.querySelectorAll('[data-product-button], [data-product-external-button]');

      buttons.forEach(function (button) {
        button.disabled = !canAdd;
        if (!canAdd) {
          button.textContent = limits.available ? 'Maximale Menge erreicht' : 'Nicht verfügbar';
        } else if (button.tagName === 'BUTTON') {
          button.textContent = 'In den Warenkorb';
        }
      });

      form.classList.toggle('is-quantity-unavailable', !canAdd);
      if (paymentButton) paymentButton.hidden = !canAdd;
    }

    function applyLimits(options) {
      var variant = currentVariantData();
      var limits = limitsForVariant(variant);
      var reset = options && options.reset === true;
      var quantity = reset
        ? (limits.maximum === 0 ? 0 : limits.minimum)
        : currentQuantity(limits);

      quantityInputs.forEach(function (input) {
        input.min = limits.maximum === 0 ? '0' : String(limits.minimum);
        input.step = String(limits.increment);
        input.value = String(quantity);
        input.disabled = limits.maximum === 0;

        if (limits.maximum !== null) {
          input.max = String(limits.maximum);
        } else {
          input.removeAttribute('max');
        }
      });

      updateButtons(quantity, limits);
      updatePurchasingState(limits);
      setMessage(limits);
    }

    function setQuantity(value) {
      var limits = limitsForVariant(currentVariantData());
      var quantity = normalizeQuantity(value, limits);

      quantityInputs.forEach(function (input) {
        input.value = String(quantity);
      });

      updateButtons(quantity, limits);
    }

    quantityInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setQuantity(input.value);
      });

      input.addEventListener('blur', function () {
        setQuantity(input.value);
      });

      input.addEventListener('input', function () {
        if (input.value === '') return;
        var limits = limitsForVariant(currentVariantData());
        var value = toInteger(input.value, limits.minimum);
        if (limits.maximum !== null && value > limits.maximum) {
          setQuantity(limits.maximum);
        }
      });
    });

    section.querySelectorAll('[data-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var limits = limitsForVariant(currentVariantData());
        var stepDirection = toInteger(button.getAttribute('data-quantity-step'), 0);
        var quantity = currentQuantity(limits) + stepDirection * limits.increment;
        setQuantity(quantity);
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        window.requestAnimationFrame(function () {
          applyLimits({ reset: true });
        });
      });
    }

    applyLimits({ reset: false });

    if (sticky && 'IntersectionObserver' in window && mainButton) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-hidden', entry.isIntersecting && entry.intersectionRatio > 0.35);
        });
      }, { threshold: [0, 0.35, 0.75] });
      observer.observe(mainButton);
    }
  }

  document.querySelectorAll('[data-product-section]').forEach(initProductQuantityLimit);
})();


// v1.24: cart quantity steppers.
(function () {
  function toNumber(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isNaN(number) ? fallback : number;
  }

  function clamp(value, min, max) {
    var next = toNumber(value, min || 1);
    next = Math.max(min || 1, next);
    if (max && max > 0) next = Math.min(max, next);
    return next;
  }

  function updateStepper(stepper, input) {
    var min = toNumber(input.getAttribute('min') || '1', 1);
    var max = toNumber(input.getAttribute('max') || '', 0);
    var qty = clamp(input.value, min, max);
    input.value = qty;
    stepper.querySelectorAll('[data-cart-quantity-step="-1"]').forEach(function (button) {
      button.disabled = qty <= min;
    });
  }

  document.querySelectorAll('[data-cart-quantity-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-cart-quantity-input]');
    if (!input) return;

    updateStepper(stepper, input);

    stepper.querySelectorAll('[data-cart-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var min = toNumber(input.getAttribute('min') || '1', 1);
        var max = toNumber(input.getAttribute('max') || '', 0);
        var step = toNumber(button.getAttribute('data-cart-quantity-step') || '0', 0);
        input.value = clamp(toNumber(input.value, min) + step, min, max);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateStepper(stepper, input);
      });
    });

    input.addEventListener('input', function () { updateStepper(stepper, input); });
    input.addEventListener('change', function () { updateStepper(stepper, input); });
  });
})();

/* ======================================================================
   SortimentPlus Light – Sortierung und Block-/Listenansicht
   Diesen Block ganz am Ende von assets/theme.js einfügen.
   ====================================================================== */
(function () {
  var storageKey = 'sortimentplus-collection-view';

  document.querySelectorAll('[data-collection-view-root]').forEach(function (root) {
    var viewButtons = root.querySelectorAll('[data-collection-view]');
    if (!root.querySelector('[data-product-grid]') || !viewButtons.length) return;
    var currentView = 'grid';

    var setView = function (view, savePreference) {
      var normalizedView = view === 'list' ? 'list' : 'grid';
      currentView = normalizedView;
      // Alle Raster abfragen (auch „Ausverkaufte Produkte“ und nach Sofort-Filter neu geladene).
      root.querySelectorAll('[data-product-grid]').forEach(function (productGrid) {
        productGrid.classList.toggle('is-list-view', normalizedView === 'list');
        productGrid.classList.toggle('is-grid-view', normalizedView === 'grid');
        productGrid.setAttribute('data-current-view', normalizedView);
      });

      viewButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-collection-view') === normalizedView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (savePreference) {
        try {
          window.localStorage.setItem(storageKey, normalizedView);
        } catch (error) {
          /* Browser blockiert Local Storage – Ansicht funktioniert trotzdem. */
        }
      }
    };

    var initialView = root.querySelector('[data-product-grid]').getAttribute('data-default-view') || 'grid';
    try {
      var savedView = window.localStorage.getItem(storageKey);
      if (savedView === 'grid' || savedView === 'list') initialView = savedView;
    } catch (error) {
      /* Standardansicht bleibt aktiv. */
    }

    setView(initialView, false);

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setView(button.getAttribute('data-collection-view'), true);
      });
    });

    // Nach dem Nachladen von Produkten (Sofort-Filter) aktuelle Ansicht erneut anwenden.
    root.addEventListener('sortimentplus:products-updated', function () {
      setView(currentView, false);
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      var value = select.value;

      if (value) {
        url.searchParams.set('sort_by', value);
      } else {
        url.searchParams.delete('sort_by');
      }

      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-filter-toggle]').forEach(function (button) {
    var filterId = button.getAttribute('aria-controls');
    var filters = filterId ? document.getElementById(filterId) : document.querySelector('[data-filters]');
    if (!filters) return;

    button.addEventListener('click', function () {
      window.requestAnimationFrame(function () {
        button.setAttribute('aria-expanded', String(filters.classList.contains('is-open')));
      });
    });
  });
})();
/* ======================================================================
   Ende SortimentPlus Light – Sortierung und Ansicht
   ====================================================================== */


/* ======================================================================
   SortimentPlus Light – Erweiterte Filterfunktionen
   Diesen Block ganz am Ende von assets/theme.js einfügen.
   ====================================================================== */
(function () {
  document.querySelectorAll('[data-facet-group]').forEach(function (group) {
    var valuesContainer = group.querySelector('[data-facet-values]');
    if (!valuesContainer) return;

    var rows = Array.prototype.slice.call(valuesContainer.querySelectorAll('[data-facet-value-row]'));
    var searchInput = group.querySelector('[data-facet-value-search]');
    var toggleButton = group.querySelector('[data-facet-values-toggle]');
    var emptyMessage = group.querySelector('[data-facet-no-results]');
    var isExpanded = toggleButton ? toggleButton.getAttribute('aria-expanded') === 'true' : true;

    var normalize = function (value) {
      return String(value || '')
        .toLocaleLowerCase('de-DE')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    };

    var updateToggle = function () {
      if (!toggleButton) return;
      var label = toggleButton.querySelector('span');
      var text = isExpanded
        ? toggleButton.getAttribute('data-less-text')
        : toggleButton.getAttribute('data-more-text');

      toggleButton.setAttribute('aria-expanded', String(isExpanded));
      if (label) label.textContent = text;
    };

    var updateRows = function () {
      var query = searchInput ? normalize(searchInput.value) : '';
      var visibleMatches = 0;

      rows.forEach(function (row) {
        var rowText = normalize(row.getAttribute('data-facet-value-text'));
        var isCollapsed = row.hasAttribute('data-collapsed-value');
        var matchesSearch = !query || rowText.indexOf(query) !== -1;
        var shouldShow = matchesSearch && (query || isExpanded || !isCollapsed);

        row.hidden = !shouldShow;
        if (shouldShow) visibleMatches += 1;
      });

      if (emptyMessage) emptyMessage.hidden = visibleMatches !== 0;
      if (toggleButton) toggleButton.hidden = Boolean(query);
    };

    if (toggleButton) {
      toggleButton.addEventListener('click', function () {
        isExpanded = !isExpanded;
        updateToggle();
        updateRows();
      });
      updateToggle();
    }

    if (searchInput) {
      searchInput.addEventListener('input', updateRows);
      searchInput.addEventListener('search', updateRows);
    }

    updateRows();
  });

  document.querySelectorAll('[data-facet-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      form.querySelectorAll('.price-range input[type="number"]').forEach(function (input) {
        if (typeof input.value === 'string') {
          input.value = input.value.replace(',', '.');
        }
      });
    });
  });
})();
/* ======================================================================
   Ende SortimentPlus Light – Erweiterte Filterfunktionen
   ====================================================================== */

/* ======================================================================
   SortimentPlus Light – dynamische obere Position des Filters
   Diesen Block ganz am Ende von assets/theme.js einfügen.
   Der Filter sitzt direkt unter einem sichtbaren Sticky-Header.
   Ist kein Header sichtbar, sitzt er 12 px unter dem oberen Fensterrand.
   Die bestehende feste Filterhöhe wird dabei nicht verändert.
   ====================================================================== */

(() => {
  const root = document.documentElement;
  const header = document.querySelector('.site-header');
  const gap = 12;
  let frame = null;

  const updateFilterStickyTop = () => {
    frame = null;
    let top = gap;

    if (header) {
      const rect = header.getBoundingClientRect();
      const style = window.getComputedStyle(header);
      const isVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.bottom > 0 &&
        rect.top < window.innerHeight;

      const isPinnedHeader = style.position === 'sticky' || style.position === 'fixed';

      if (isVisible && isPinnedHeader) {
        top = Math.max(gap, Math.round(rect.bottom + gap));
      }
    }

    root.style.setProperty('--sp-filter-sticky-top', `${top}px`);
  };

  const requestUpdate = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateFilterStickyTop);
  };

  requestUpdate();
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });

  if (header && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(requestUpdate);
    observer.observe(header);
  }
})();

/* ======================================================================
   Ende SortimentPlus Light – dynamische obere Filterposition
   ====================================================================== */


/* ============================================================
   IDEALO / MWST: Produktseitigen MwSt.-Betrag bei Variantenwechsel
   aktualisieren. Ganz ans Ende von assets/theme.js einfügen.
   ============================================================ */
(function () {
  document.querySelectorAll('[data-product-vat]').forEach(function (vatElement) {
    const productSection = vatElement.closest('[data-product-section]');
    const variantSelect = productSection ? productSection.querySelector('[data-variant-select]') : null;
    const amountElement = vatElement.querySelector('[data-product-vat-amount]');
    const dataElement = vatElement.querySelector('[data-product-vat-variants]');

    if (!amountElement || !dataElement) return;

    let variants = [];
    try {
      variants = JSON.parse(dataElement.textContent || '[]');
    } catch (error) {
      return;
    }

    const updateVatAmount = function () {
      const selectedVariantId = variantSelect
        ? String(variantSelect.value)
        : String(vatElement.dataset.selectedVariantId || '');

      const selectedVariant = variants.find(function (variant) {
        return String(variant.id) === selectedVariantId;
      });

      if (!selectedVariant || !selectedVariant.taxable) {
        vatElement.hidden = true;
        return;
      }

      amountElement.textContent = selectedVariant.vatAmount;
      vatElement.hidden = false;
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', updateVatAmount);
    }

    updateVatAmount();
  });
})();


/* ============================================================
   MOBILE SCHNELLKATEGORIEN V2
   Ganz ans Ende von assets/theme.js einfügen.
   Erzeugt echte Pfeil-Buttons und scrollt die Kategorien.
   ============================================================ */
(() => {
  const initQuickCategories = (root = document) => {
    root.querySelectorAll('.mobile-quick-cats').forEach((track) => {
      if (track.dataset.quickCategoriesReady === 'true') return;
      track.dataset.quickCategoriesReady = 'true';

      const parent = track.parentNode;
      if (!parent) return;

      const shell = document.createElement('div');
      shell.className = 'page-width page-width--header mobile-quick-cats-shell';
      shell.setAttribute('data-mobile-quick-cats-shell', '');

      const previousButton = document.createElement('button');
      previousButton.type = 'button';
      previousButton.className = 'mobile-quick-cats__arrow mobile-quick-cats__arrow--previous';
      previousButton.setAttribute('aria-label', 'Vorherige Kategorien anzeigen');
      previousButton.innerHTML = '<span aria-hidden="true">‹</span>';

      const nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'mobile-quick-cats__arrow mobile-quick-cats__arrow--next';
      nextButton.setAttribute('aria-label', 'Weitere Kategorien anzeigen');
      nextButton.innerHTML = '<span aria-hidden="true">›</span>';

      parent.insertBefore(shell, track);
      shell.append(previousButton, track, nextButton);

      /* Die Breite liegt jetzt auf dem neuen Wrapper, nicht mehr auf der Scrollspur. */
      track.classList.remove('page-width', 'page-width--header');

      const updateButtons = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const noOverflow = maximumScroll <= 3;

        shell.classList.toggle('is-static', noOverflow);
        previousButton.disabled = noOverflow || track.scrollLeft <= 3;
        nextButton.disabled = noOverflow || track.scrollLeft >= maximumScroll - 3;
      };

      const scrollTrack = (direction) => {
        const distance = Math.max(130, Math.round(track.clientWidth * 0.78));
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollTrack(-1);
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollTrack(1);
      });

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateButtons();
          ticking = false;
        });
      }, { passive: true });

      window.addEventListener('resize', updateButtons, { passive: true });
      window.requestAnimationFrame(updateButtons);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initQuickCategories());
  } else {
    initQuickCategories();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initQuickCategories(event.target);
  });
})();
/* ============================================================
   ENDE MOBILE SCHNELLKATEGORIEN V2
   ============================================================ */

/* ============================================================
   SortimentPlus Light – Verfügbare Artikel strikt zuerst

   Entfernt kundenseitige sort_by-Parameter, deaktiviert versteckte
   Sortierfelder und kennzeichnet die aktive Verfügbarkeitsreihenfolge.
   Voraussetzung: Die Collection-Reihenfolge wird im Shopify-Admin durch
   eine App automatisch auf "verfügbar zuerst" gepflegt.
   ============================================================ */
(() => {
  const SELECTORS = {
    root: '[data-collection-view-root], .collection-main, .collection-products',
    actions: '.collection-toolbar__actions',
    sortControl: '.collection-sort-control',
    sortSelect: '[data-collection-sort], select[name="sort_by"]',
    sortInputs: 'input[name="sort_by"]',
    viewSwitch: '.collection-view-switch'
  };

  const stripSortParameter = () => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('sort_by')) return false;

    url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    window.location.replace(url.toString());
    return true;
  };

  const initAvailabilityFirst = () => {
    if (!document.querySelector(SELECTORS.root)) return;
    if (stripSortParameter()) return;

    document.querySelectorAll(SELECTORS.sortInputs).forEach((input) => {
      input.disabled = true;
    });

    document.querySelectorAll(SELECTORS.sortSelect).forEach((select) => {
      select.disabled = true;
      select.removeAttribute('name');
    });

    document.querySelectorAll(SELECTORS.sortControl).forEach((control) => {
      control.setAttribute('hidden', '');
      control.setAttribute('aria-hidden', 'true');
    });

    const actions = document.querySelector(SELECTORS.actions);
    if (!actions || actions.querySelector('.collection-availability-order')) return;

    const label = document.createElement('span');
    label.className = 'collection-availability-order';
    label.textContent = 'Verfügbare Artikel zuerst';

    const viewSwitch = actions.querySelector(SELECTORS.viewSwitch);
    actions.insertBefore(label, viewSwitch || actions.firstChild);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAvailabilityFirst, { once: true });
  } else {
    initAvailabilityFirst();
  }

  window.addEventListener('pageshow', initAvailabilityFirst);
})();
/* ============================================================
   Ende – Verfügbare Artikel strikt zuerst
   ============================================================ */


/* ============================================================
   Produktseite: Steuerhinweise abhängig von der gewählten Variante
   Ganz ans Ende von assets/theme.js einfügen.
   ============================================================ */
(function () {
  function initTaxDisplays(root) {
    (root || document).querySelectorAll('[data-product-tax-display]').forEach(function (wrapper) {
      if (wrapper.dataset.taxDisplayInitialized === 'true') return;
      wrapper.dataset.taxDisplayInitialized = 'true';

      const section = wrapper.closest('[data-product-section]');
      const variantSelect = section ? section.querySelector('[data-variant-select]') : null;
      const standardNote = wrapper.querySelector('[data-standard-tax-note]');
      const differentialNote = wrapper.querySelector('[data-differential-tax-note]');
      const vatElement = wrapper.querySelector('[data-product-vat]');
      const vatAmountElement = vatElement ? vatElement.querySelector('[data-product-vat-amount]') : null;
      const vatDataElement = vatElement ? vatElement.querySelector('[data-product-vat-variants]') : null;

      let vatVariants = [];
      if (vatDataElement) {
        try {
          vatVariants = JSON.parse(vatDataElement.textContent || '[]');
        } catch (error) {
          vatVariants = [];
        }
      }

      function getSelectedState() {
        let selectedId = vatElement ? String(vatElement.dataset.selectedVariantId || '') : '';
        let taxable = wrapper.dataset.initialTaxable === 'true';

        if (variantSelect) {
          selectedId = String(variantSelect.value || '');
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          if (selectedOption && typeof selectedOption.dataset.taxable !== 'undefined') {
            taxable = selectedOption.dataset.taxable === 'true';
          }
        }

        const vatVariant = vatVariants.find(function (item) {
          return String(item.id) === selectedId;
        });

        if (vatVariant && typeof vatVariant.taxable !== 'undefined') {
          taxable = Boolean(vatVariant.taxable);
        }

        return { taxable: taxable, vatVariant: vatVariant };
      }

      function updateTaxDisplay() {
        const state = getSelectedState();
        const taxesIncluded = wrapper.dataset.taxesIncluded === 'true';
        const isDifferential = wrapper.dataset.differential === 'true';

        if (standardNote) {
          standardNote.hidden = !(state.taxable && taxesIncluded);
        }

        if (differentialNote) {
          differentialNote.hidden = !(!state.taxable && isDifferential);
        }

        if (vatElement) {
          if (!state.taxable || !taxesIncluded || !state.vatVariant) {
            vatElement.hidden = true;
          } else {
            if (vatAmountElement && state.vatVariant.vatAmount) {
              vatAmountElement.textContent = state.vatVariant.vatAmount;
            }
            vatElement.hidden = false;
          }
        }
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', updateTaxDisplay);
      }

      updateTaxDisplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTaxDisplays(document);
    });
  } else {
    initTaxDisplays(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTaxDisplays(event.target);
  });
})();


// SortimentPlus Light: horizontal controls for product review cards.
(() => {
  const initProductReviews = (section) => {
    if (!section || section.dataset.productReviewsReady === 'true') return;

    const track = section.querySelector('[data-review-track]');
    const previousButton = section.querySelector('[data-review-scroll="previous"]');
    const nextButton = section.querySelector('[data-review-scroll="next"]');

    if (!track) return;
    section.dataset.productReviewsReady = 'true';

    const getScrollStep = () => {
      const card = track.querySelector('.product-review-card');
      if (!card) return Math.max(track.clientWidth * 0.8, 260);
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      if (!previousButton || !nextButton) return;
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      previousButton.disabled = track.scrollLeft <= 3;
      nextButton.disabled = track.scrollLeft >= maxScroll - 3;
    };

    previousButton?.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    nextButton?.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(track);
    }

    updateButtons();
  };

  const initAllProductReviews = (root = document) => {
    root.querySelectorAll('[data-product-reviews]').forEach(initProductReviews);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllProductReviews());
  } else {
    initAllProductReviews();
  }

  document.addEventListener('shopify:section:load', (event) => initAllProductReviews(event.target));
})();

/* ======================================================================
   SORTIMENTPLUS LIGHT – MOBILE PRODUKTSEITE CRO V1
   Ganz ans Ende von assets/theme.js einfügen.
   Der Code ist bewusst modular und ersetzt keine bestehende Desktop-Logik.
   ====================================================================== */
(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const headerMobileQuery = window.matchMedia('(max-width: 990px)');
  let productSection = document.querySelector('[data-product-section]');

  if (!productSection) return;

  document.body.classList.add('is-mobile-product-page');

  /* ----------------------------------------------------------
     Header-Suche: Button dynamisch einfügen, vorhandenes Suchformular nutzen
     ---------------------------------------------------------- */
  const initProductHeaderSearch = () => {
    const header = document.querySelector('[data-header], .site-header');
    const mainInner = header?.querySelector('.site-header__main-inner');
    const actions = mainInner?.querySelector('.site-header__actions');
    const tools = header?.querySelector('.site-header__mobile-tools');
    const searchRow = tools?.querySelector('.site-header__mobile-search-row');
    const searchInput = searchRow?.querySelector('input[type="search"]');

    if (!header || !mainInner || !actions || !tools || !searchRow || !searchInput) return;
    if (header.dataset.productSearchReady === 'true') return;
    header.dataset.productSearchReady = 'true';

    if (!tools.id) tools.id = 'MobileProductSearch';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'mobile-header-search-toggle';
    toggle.setAttribute('aria-label', 'Suche öffnen');
    toggle.setAttribute('aria-controls', tools.id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.7-3.7"></path></svg>';
    mainInner.insertBefore(toggle, actions);

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'mobile-product-search-close';
    close.setAttribute('aria-label', 'Suche schließen');
    close.textContent = '×';
    searchRow.appendChild(close);

    const openSearch = () => {
      header.classList.add('is-product-search-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Suche schließen');
      window.setTimeout(() => searchInput.focus({ preventScroll: true }), 80);
    };

    const closeSearch = () => {
      header.classList.remove('is-product-search-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Suche öffnen');
      searchInput.blur();
    };

    toggle.addEventListener('click', () => {
      if (header.classList.contains('is-product-search-open')) closeSearch();
      else openSearch();
    });

    close.addEventListener('click', closeSearch);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && header.classList.contains('is-product-search-open')) {
        closeSearch();
        toggle.focus();
      }
    });

    headerMobileQuery.addEventListener?.('change', (event) => {
      if (!event.matches) closeSearch();
    });
  };

  /* ----------------------------------------------------------
     Auf einen Blick: Trust-Punkte priorisieren und auf 4 begrenzen
     ---------------------------------------------------------- */
  const bulletState = new WeakMap();

  const getPriority = (text, originalIndex) => {
    const value = text.toLocaleLowerCase('de-DE');
    if (/neuware|originalverpack|original verpackt|\bovp\b/.test(value)) return 10;
    if (/rechnung/.test(value) && /(19\s*%|mwst|umsatzsteuer)/.test(value)) return 20;
    if (/versand/.test(value) && /(deutschland|dhl)/.test(value)) return 30;
    return 100 + originalIndex;
  };

  const findMobileBulletContainer = () => {
    const candidates = productSection.querySelectorAll('.product-summary-card .product-intro--bullets, .product-summary-card .product-highlights');
    return Array.from(candidates).find((container) => {
      const heading = container.querySelector('h2');
      return !heading || /auf einen blick/i.test(heading.textContent || '');
    }) || candidates[0];
  };

  const applyMobileBullets = () => {
    const container = findMobileBulletContainer();
    if (!container) return;
    const list = container.querySelector('ul');
    if (!list) return;

    if (!bulletState.has(list)) {
      bulletState.set(list, {
        items: Array.from(list.children),
        classes: Array.from(list.children).map((item) => item.className),
        hidden: Array.from(list.children).map((item) => item.hidden),
        linkHidden: container.querySelector('a[href="#produktdetails"]')?.hidden || false
      });
    }

    const state = bulletState.get(list);
    const link = container.querySelector('a[href="#produktdetails"]');

    if (!mobileQuery.matches) {
      state.items.forEach((item, index) => {
        list.appendChild(item);
        item.className = state.classes[index];
        item.hidden = state.hidden[index];
      });
      container.classList.remove('mobile-priority-bullets');
      if (link) link.hidden = state.linkHidden;
      return;
    }

    const sorted = state.items
      .map((item, index) => ({ item, index, priority: getPriority(item.textContent || '', index) }))
      .sort((a, b) => a.priority - b.priority || a.index - b.index);

    sorted.forEach(({ item }, index) => {
      list.appendChild(item);
      item.classList.remove('product-bullet--mobile-hidden');
      item.hidden = index >= 4;
    });

    container.classList.add('mobile-priority-bullets');
    if (link) link.hidden = state.items.length <= 4;
  };

  /* ----------------------------------------------------------
     Reviews vor Produktbeschreibung verschieben (nur Mobile)
     ---------------------------------------------------------- */
  let reviewOriginalParent = null;
  let reviewOriginalNextSibling = null;

  const placeReviews = () => {
    const reviews = productSection.querySelector('.product-reviews');
    const details = productSection.querySelector('.product-details-layout');
    if (!reviews || !details) return;

    if (!reviewOriginalParent) {
      reviewOriginalParent = reviews.parentNode;
      reviewOriginalNextSibling = reviews.nextSibling;
    }

    if (mobileQuery.matches) {
      if (details.parentNode === reviews.parentNode && reviews.nextElementSibling !== details) {
        details.parentNode.insertBefore(reviews, details);
      }
    } else if (reviewOriginalParent) {
      reviewOriginalParent.insertBefore(reviews, reviewOriginalNextSibling);
    }
  };

  /* ----------------------------------------------------------
     Produktbeschreibung einklappen
     ---------------------------------------------------------- */
  const initDescriptionToggle = () => {
    const card = productSection.querySelector('.product-description-card');
    const description = card?.querySelector('.product-description');
    if (!card || !description) return;
    if (card.dataset.mobileDescriptionReady === 'true') return;
    card.dataset.mobileDescriptionReady = 'true';

    let button = card.querySelector('.product-description-toggle');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-description-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Mehr anzeigen';
      description.insertAdjacentElement('afterend', button);
    }

    const calculateCollapsedHeight = () => {
      const firstHeading = Array.from(description.children).find((element) => /^(H2|H3)$/.test(element.tagName));
      const textElement = firstHeading
        ? Array.from(description.children).find((element) => element.compareDocumentPosition(firstHeading) & Node.DOCUMENT_POSITION_PRECEDING && /^(P|UL|OL)$/.test(element.tagName))
        : description.querySelector('p, ul, ol');
      const reference = textElement || firstHeading || description;
      const computed = window.getComputedStyle(reference);
      const lineHeight = Number.parseFloat(computed.lineHeight) || 24;
      const headingBottom = firstHeading ? firstHeading.offsetTop + firstHeading.offsetHeight + 12 : 0;
      return Math.max(230, Math.min(360, headingBottom + (lineHeight * 7) + 18));
    };

    const refresh = () => {
      if (!mobileQuery.matches) {
        description.classList.remove('is-mobile-collapsed', 'is-mobile-expanded');
        button.hidden = true;
        return;
      }

      const collapsedHeight = calculateCollapsedHeight();
      description.style.setProperty('--mobile-description-collapsed-height', `${collapsedHeight}px`);
      const needsToggle = description.scrollHeight > collapsedHeight + 20;
      button.hidden = !needsToggle;

      if (needsToggle && button.getAttribute('aria-expanded') !== 'true') {
        description.classList.add('is-mobile-collapsed');
        description.classList.remove('is-mobile-expanded');
      }
    };

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? 'Mehr anzeigen' : 'Weniger anzeigen';
      description.classList.toggle('is-mobile-expanded', !expanded);
      description.classList.toggle('is-mobile-collapsed', expanded);
    });

    window.addEventListener('resize', refresh, { passive: true });
    document.fonts?.ready?.then(refresh);
    refresh();
  };

  /* ----------------------------------------------------------
     Review-Karten: Mehr lesen / Weniger lesen
     ---------------------------------------------------------- */
  const initReviewReadMore = () => {
    productSection.querySelectorAll('.product-review-card').forEach((card) => {
      const text = card.querySelector('.product-review-card__text');
      if (!text || card.dataset.mobileReviewReady === 'true') return;
      card.dataset.mobileReviewReady = 'true';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-review-read-more';
      button.textContent = 'Mehr lesen';
      button.setAttribute('aria-expanded', 'false');
      text.insertAdjacentElement('afterend', button);

      const refresh = () => {
        if (!mobileQuery.matches) {
          text.classList.remove('is-mobile-collapsed', 'is-mobile-expanded');
          button.hidden = true;
          return;
        }

        if (button.getAttribute('aria-expanded') !== 'true') {
          text.classList.add('is-mobile-collapsed');
          text.classList.remove('is-mobile-expanded');
        }

        const longText = (text.textContent || '').trim().length > 280;
        const overflowing = text.scrollHeight > text.clientHeight + 3;
        button.hidden = !(longText || overflowing);
      };

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? 'Mehr lesen' : 'Weniger lesen';
        text.classList.toggle('is-mobile-expanded', !expanded);
        text.classList.toggle('is-mobile-collapsed', expanded);
      });

      refresh();
      window.addEventListener('resize', refresh, { passive: true });
    });
  };

  /* ----------------------------------------------------------
     Sticky CTA mit Hysterese + getrenntes Tracking
     ---------------------------------------------------------- */
  const emitAtcEvent = (eventName, element) => {
    const detail = {
      event: eventName,
      productId: productSection.dataset.productId || null,
      variantId: productSection.querySelector('[name="id"]')?.value || null,
      source: eventName === 'sticky_atc_click' ? 'sticky' : 'main'
    };

    window.dataLayer?.push(detail);
    if (typeof window.clarity === 'function') window.clarity('event', eventName);
    document.dispatchEvent(new CustomEvent(eventName, { detail }));
    element?.setAttribute('data-last-atc-event', eventName);
  };

  const initStickyAtc = () => {
    const mainButton = productSection.querySelector('.product-form__submit[data-product-button], .product-form__submit');
    const sticky = productSection.querySelector('[data-product-mobile-sticky]');
    if (!mainButton || !sticky) return;
    if (sticky.dataset.mobileStickyReady === 'true') return;
    sticky.dataset.mobileStickyReady = 'true';

    let pendingTimer = null;
    let currentState = '';

    const setState = (state) => {
      if (state === currentState) return;
      currentState = state;
      sticky.dataset.mobileStickyState = state;
      sticky.classList.toggle('is-hidden', state === 'hidden');
    };

    const scheduleState = (state) => {
      window.clearTimeout(pendingTimer);
      pendingTimer = window.setTimeout(() => setState(state), 90);
    };

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const ratio = entry.intersectionRatio || 0;
      if (entry.isIntersecting && ratio >= 0.35) scheduleState('hidden');
      else if (!entry.isIntersecting || ratio <= 0.08) scheduleState('visible');
    }, {
      threshold: [0, 0.08, 0.35, 0.6],
      rootMargin: '-8px 0px -8px 0px'
    });

    observer.observe(mainButton);

    if (mainButton.dataset.atcTrackingReady !== 'true') {
      mainButton.dataset.atcTrackingReady = 'true';
      mainButton.addEventListener('click', () => emitAtcEvent('main_atc_click', mainButton));
    }

    const stickyButton = sticky.querySelector('button[data-product-external-button], button.button');
    if (stickyButton && stickyButton.dataset.atcTrackingReady !== 'true') {
      stickyButton.dataset.atcTrackingReady = 'true';
      stickyButton.addEventListener('click', () => emitAtcEvent('sticky_atc_click', stickyButton));
    }
  };

  /* ----------------------------------------------------------
     Bestandsmeldung erst nahe am Limit zeigen
     ---------------------------------------------------------- */
  const initMobileQuantityMessage = () => {
    const form = productSection.querySelector('.product-form--buybox');
    const input = form?.querySelector('[data-quantity-input], input[name="quantity"]');
    if (!form || !input) return;
    if (form.dataset.mobileQuantityMessageReady === 'true') return;
    form.dataset.mobileQuantityMessageReady = 'true';

    let userTouchedQuantity = false;

    const refresh = () => {
      const message = form.querySelector('[data-quantity-message], .product-quantity-message');
      if (!message) return;

      const value = Number.parseInt(input.value || '1', 10);
      const maximum = Number.parseInt(input.max || '', 10);
      const hasMaximum = Number.isFinite(maximum);
      const distance = hasMaximum ? maximum - value : Number.POSITIVE_INFINITY;
      const toneImportant = message.dataset.tone === 'warning' || message.dataset.tone === 'error';
      const veryLowStock = hasMaximum && maximum <= 2;
      const nearLimit = hasMaximum && userTouchedQuantity && distance <= 2;

      message.classList.toggle('is-mobile-limit-visible', toneImportant || veryLowStock || nearLimit);
    };

    form.querySelectorAll('[data-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        userTouchedQuantity = true;
        window.setTimeout(refresh, 0);
      });
    });

    input.addEventListener('input', () => {
      userTouchedQuantity = true;
      refresh();
    });
    input.addEventListener('change', refresh);

    const observer = new MutationObserver(refresh);
    observer.observe(form, { subtree: true, childList: true, characterData: true, attributes: true });
    refresh();
  };

  const applyResponsiveLayout = () => {
    applyMobileBullets();
    placeReviews();
    initReviewReadMore();
  };

  const initAll = () => {
    initProductHeaderSearch();
    initDescriptionToggle();
    initStickyAtc();
    initMobileQuantityMessage();
    applyResponsiveLayout();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  mobileQuery.addEventListener?.('change', applyResponsiveLayout);
  document.addEventListener('shopify:section:load', (event) => {
    const freshSection = event.target.matches?.('[data-product-section]')
      ? event.target
      : event.target.querySelector?.('[data-product-section]');
    if (freshSection) productSection = freshSection;
    window.setTimeout(initAll, 0);
  });
})();
/* ======================================================================
   ENDE – MOBILE PRODUKTSEITE CRO V1
   ====================================================================== */

// SortimentPlus Light: Mobile Review-Karten kompakt und robust.
(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const enhanceCard = (card) => {
    if (!card) return;

    // Der generische Fallback soll mobil keinen Platzhalter darstellen.
    card.querySelectorAll('.product-review-card__source').forEach((source) => {
      const isFallback = normalizeText(source.textContent) === 'kundenbewertung';
      source.classList.toggle('is-mobile-review-placeholder', isFallback);
    });

    const text = card.querySelector('.product-review-card__text');
    if (!text) return;

    // Bestehenden Mehr-lesen-Button aus dem Mobile-CRO-Patch weiterverwenden.
    let button = card.querySelector('.product-review-read-more');
    if (button) return;

    // Fallback, falls der bisherige Mobile-CRO-JS nicht installiert ist.
    button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-review-read-more';
    button.textContent = 'Mehr lesen';
    button.setAttribute('aria-expanded', 'false');
    text.insertAdjacentElement('afterend', button);
    card.dataset.mobileReviewReady = 'true';

    const refresh = () => {
      if (!mobileQuery.matches) {
        text.classList.remove('is-mobile-collapsed', 'is-mobile-expanded');
        button.hidden = true;
        return;
      }

      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (!expanded) {
        text.classList.add('is-mobile-collapsed');
        text.classList.remove('is-mobile-expanded');
      }

      requestAnimationFrame(() => {
        const longText = normalizeText(text.textContent).length > 220;
        const overflowing = text.scrollHeight > text.clientHeight + 3;
        button.hidden = !(longText || overflowing);
      });
    };

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;

      button.setAttribute('aria-expanded', String(nextExpanded));
      button.textContent = nextExpanded ? 'Weniger anzeigen' : 'Mehr lesen';
      text.classList.toggle('is-mobile-expanded', nextExpanded);
      text.classList.toggle('is-mobile-collapsed', !nextExpanded);
    });

    refresh();
    window.addEventListener('resize', refresh, { passive: true });
  };

  const init = (root = document) => {
    root.querySelectorAll('.product-review-card').forEach(enhanceCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


/* ============================================================
   SortimentPlus – reine Darstellungsanpassung der vorhandenen
   Bestandsmeldung. Die Bestands- und Mengenlogik selbst bleibt unverändert.
   Ganz ans Ende von assets/theme.js einfügen.
   ============================================================ */
(function () {
  'use strict';

  function normalizeQuantityMessage(message) {
    if (!message) return;

    var original = (message.textContent || '').trim();
    var normalized = original.replace(
      /^Nur noch\s+(\d+)\s+Stück\s+verfügbar\.?$/i,
      'Nur noch $1 verfügbar'
    );

    if (normalized !== original) {
      message.textContent = normalized;
    }

    var currentText = (message.textContent || '').trim();
    var tone = message.dataset.tone || 'neutral';
    var kind = 'neutral';

    if (/^Nur noch\s+\d+\s+verfügbar$/i.test(currentText)) {
      kind = 'low-stock';
    } else if (tone === 'error' || tone === 'warning') {
      kind = 'blocking';
    }

    message.dataset.quantityMessageKind = kind;
  }

  function initSection(section) {
    var message = section.querySelector('[data-quantity-message]');
    if (!message || message.dataset.compactQuantityObserver === 'true') return;

    message.dataset.compactQuantityObserver = 'true';
    normalizeQuantityMessage(message);

    var observer = new MutationObserver(function () {
      normalizeQuantityMessage(message);
    });

    observer.observe(message, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-tone', 'hidden']
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-product-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
/* ============================================================
   Ende – Bestandsmeldung Darstellung
   ============================================================ */

/* ============================================================
   MOBILE PRODUKTBESCHREIBUNG – SCROLLPOSITION NACH EINKLAPPEN

   - greift nur auf Mobile bis 749 px
   - nur beim Wechsel von „Weniger anzeigen“ zu „Mehr anzeigen“
   - wartet zwei Rendering-Frames auf den neuen Dokumentfluss
   - positioniert das untere Ende des eingeklappten Bereichs direkt
     oberhalb der sichtbaren Sticky-ATC-Bar
   - respektiert prefers-reduced-motion
   ============================================================ */
(() => {
  'use strict';

  if (window.__spMobileDescriptionCollapseScrollFix) return;
  window.__spMobileDescriptionCollapseScrollFix = true;

  const mobileMedia = window.matchMedia('(max-width: 749px)');
  const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
  const toggleSelector = [
    '.product-description-toggle',
    '[data-mobile-description-toggle]',
    '.product-description__toggle'
  ].join(',');

  let correctionId = 0;

  const isStickyBarVisible = (element) => {
    if (!element || element.classList.contains('is-hidden')) return false;

    const style = window.getComputedStyle(element);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      Number.parseFloat(style.opacity || '1') <= 0.01
    ) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const getVisibleStickyHeight = () => {
    const stickyBar = document.querySelector(
      '[data-product-mobile-sticky], .product-mobile-sticky-cta'
    );

    return isStickyBarVisible(stickyBar)
      ? Math.ceil(stickyBar.getBoundingClientRect().height)
      : 0;
  };

  const scrollWithoutMotion = (top) => {
    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;

    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, top);

    requestAnimationFrame(() => {
      root.style.scrollBehavior = previousScrollBehavior;
    });
  };

  const correctScrollAfterCollapse = (button, id) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (id !== correctionId || !button.isConnected || !mobileMedia.matches) return;

        /* Nur korrigieren, wenn die bestehende Logik inzwischen wirklich
           auf den eingeklappten Zustand gewechselt hat. */
        if (button.getAttribute('aria-expanded') === 'true') return;

        const descriptionCard = button.closest('.product-description-card');
        if (!descriptionCard) return;

        const stickyHeight = getVisibleStickyHeight();
        const spacing = 16;

        /* Der Button ist das zuverlässigste untere Ende des eingeklappten
           Description-Bereichs. So landen die letzten sichtbaren Zeilen,
           „Mehr anzeigen“ und der Beginn des Folgebereichs im Viewport. */
        const buttonBottom = button.getBoundingClientRect().bottom + window.scrollY;
        const targetTop = buttonBottom - window.innerHeight + stickyHeight + spacing;
        const maxScroll = Math.max(
          0,
          document.documentElement.scrollHeight - window.innerHeight
        );
        const clampedTop = Math.min(maxScroll, Math.max(0, targetTop));

        if (reducedMotionMedia.matches) {
          scrollWithoutMotion(clampedTop);
          return;
        }

        window.scrollTo({
          top: clampedTop,
          behavior: 'smooth'
        });
      });
    });
  };

  /* Capture-Phase: aria-expanded wird vor der bestehenden Toggle-Logik
     gelesen. Dadurch erkennen wir sicher, ob der Nutzer gerade über
     „Weniger anzeigen“ einklappt. */
  document.addEventListener(
    'click',
    (event) => {
      if (!mobileMedia.matches) return;

      const button = event.target.closest(toggleSelector);
      if (!button || !button.closest('.product-description-card')) return;

      const wasExpanded = button.getAttribute('aria-expanded') === 'true';
      if (!wasExpanded) return;

      correctionId += 1;
      correctScrollAfterCollapse(button, correctionId);
    },
    true
  );
})();

/* ======================================================================
   SORTIMENTPLUS LIGHT – MOBILE PRODUKTGALERIE ALS ECHTER DRAG-CAROUSEL V2.1 – SMOOTHER SNAP

   Verhalten:
   - Track folgt dem Finger live per translate3d().
   - Distanz- oder Velocity-Schwelle entscheidet beim Loslassen.
   - Edge Resistance am ersten/letzten Bild.
   - Thumbnail-Klick und Drag bleiben synchron.
   - Vertikales Seitenscrollen bleibt durch touch-action: pan-y erhalten.
   - Kompatibilitätsmodus blockiert den älteren einfachen Swipe-Patch,
     sobald eine horizontale Drag-Geste erkannt wurde.
   ====================================================================== */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var AXIS_LOCK_DISTANCE = 10;
  var HORIZONTAL_RATIO = 1.2;
  var DISTANCE_RATIO = 0.22;
  var VELOCITY_THRESHOLD = 0.42; // px / ms
  var EDGE_RESISTANCE = 0.4;
  var SNAP_MIN_DURATION = 320;
  var SNAP_MAX_DURATION = 460;
  var SNAP_EASING = 'cubic-bezier(.22, .78, .2, 1)';

  var mobileMedia = window.matchMedia(MOBILE_QUERY);
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = new WeakMap();

  function asArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getGalleries(root) {
    var galleries = [];

    if (root && root.matches && root.matches('[data-product-gallery]')) {
      galleries.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
        galleries.push(gallery);
      });
    }

    return galleries;
  }

  function createCarousel(gallery) {
    if (!gallery || instances.has(gallery)) return instances.get(gallery) || null;

    var stage = gallery.querySelector('.product-gallery__stage');
    var thumbsContainer = gallery.querySelector('.product-gallery__thumbs');
    var buttons = asArray(gallery.querySelectorAll('[data-gallery-target]'));
    var items = asArray(gallery.querySelectorAll('.product-gallery__item'));

    if (!stage || buttons.length < 2 || items.length < 2) return null;

    var controller = new AbortController();
    var signal = controller.signal;
    var track = document.createElement('div');
    track.className = 'mobile-gallery-track';

    var currentIndex = buttons.findIndex(function (button) {
      return button.classList.contains('is-active') || button.getAttribute('aria-current') === 'true';
    });
    if (currentIndex < 0) currentIndex = 0;

    var width = 0;
    var isDragging = false;
    var axis = null;
    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var lastX = 0;
    var lastTime = 0;
    var deltaX = 0;
    var deltaY = 0;
    var velocityX = 0;
    var activePointerId = null;
    var suppressClickUntil = 0;
    var internalThumbChange = false;
    var resizeFrame = 0;
    var renderedOffset = 0;

    items.forEach(function (item, index) {
      item.hidden = false;
      item.classList.add('mobile-gallery-slide');
      item.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true');
      if ('inert' in item) item.inert = index !== currentIndex;
      track.appendChild(item);
    });

    stage.appendChild(track);
    stage.classList.add('is-mobile-drag-carousel');
    gallery.dataset.mobileDragCarouselReady = 'true';

    function measure() {
      width = stage.getBoundingClientRect().width || stage.clientWidth || 1;
      return width;
    }

    function targetOffset(index) {
      return -(index * (width || measure()));
    }

    function getSnapDuration(targetPx) {
      var galleryWidth = width || measure();
      var remainingDistance = Math.abs(targetPx - renderedOffset);
      var distanceRatio = clamp(remainingDistance / galleryWidth, 0, 1);

      /* Kurze Rückschnapper bleiben kontrolliert, größere Restwege erhalten
         bewusst mehr Zeit. Dadurch fällt das Bild nach dem Loslassen nicht
         mehr abrupt auf die Zielposition. */
      return Math.round(
        SNAP_MIN_DURATION + ((SNAP_MAX_DURATION - SNAP_MIN_DURATION) * distanceRatio)
      );
    }

    function setTransform(px, animate) {
      var duration = getSnapDuration(px);

      track.style.transition = animate && !reducedMotion.matches
        ? 'transform ' + duration + 'ms ' + SNAP_EASING
        : 'none';
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
      renderedOffset = px;
    }

    function keepAllSlidesMounted() {
      items.forEach(function (item) {
        item.hidden = false;
      });
    }

    function updateAccessibility(index) {
      items.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in item) item.inert = !active;
      });
    }

    function updateThumbnails(index) {
      buttons.forEach(function (button, buttonIndex) {
        var active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function centerThumbnail(index, smooth) {
      if (!thumbsContainer || !buttons[index]) return;

      var button = buttons[index];
      var maxScroll = Math.max(0, thumbsContainer.scrollWidth - thumbsContainer.clientWidth);
      var desiredLeft = button.offsetLeft - ((thumbsContainer.clientWidth - button.offsetWidth) / 2);
      var boundedLeft = clamp(desiredLeft, 0, maxScroll);

      thumbsContainer.scrollTo({
        left: boundedLeft,
        behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto'
      });
    }

    function preload(index) {
      if (index < 0 || index >= items.length) return;
      var image = items[index].querySelector('img');
      if (!image || image.complete) return;

      image.loading = 'eager';
      var loader = new Image();
      if (image.srcset) loader.srcset = image.srcset;
      if (image.sizes) loader.sizes = image.sizes;
      loader.src = image.currentSrc || image.src;
    }

    function preloadNeighbours(index) {
      preload(index - 1);
      preload(index + 1);
    }

    function commitIndex(index, animate, source) {
      var nextIndex = clamp(index, 0, items.length - 1);
      var previousIndex = currentIndex;
      currentIndex = nextIndex;

      keepAllSlidesMounted();
      updateAccessibility(currentIndex);
      updateThumbnails(currentIndex);
      setTransform(targetOffset(currentIndex), animate);
      centerThumbnail(currentIndex, animate);
      preloadNeighbours(currentIndex);

      if (previousIndex !== currentIndex) {
        gallery.dispatchEvent(new CustomEvent('product-gallery:change', {
          bubbles: true,
          detail: {
            index: currentIndex,
            previousIndex: previousIndex,
            source: source || 'carousel',
            direction: currentIndex > previousIndex ? 'next' : 'previous'
          }
        }));
      }
    }

    function resetGestureState() {
      isDragging = false;
      axis = null;
      deltaX = 0;
      deltaY = 0;
      velocityX = 0;
      activePointerId = null;
      stage.classList.remove('is-dragging');
    }

    function snapBack() {
      setTransform(targetOffset(currentIndex), true);
      resetGestureState();
    }

    function finishGesture(clientX, clientY, event) {
      if (!isDragging) return;

      deltaX = clientX - startX;
      deltaY = clientY - startY;

      if (axis !== 'x') {
        resetGestureState();
        return;
      }

      /* Verhindert, dass der vorherige einfache Swipe-Patch beim Loslassen
         zusätzlich einen sofortigen Bildwechsel ausführt. */
      if (event && typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }

      var galleryWidth = width || measure();
      var distancePassed = Math.abs(deltaX) >= galleryWidth * DISTANCE_RATIO;
      var velocityPassed = Math.abs(velocityX) >= VELOCITY_THRESHOLD;
      var direction = deltaX < 0 ? 1 : -1;
      var candidate = currentIndex + direction;
      var canMove = candidate >= 0 && candidate < items.length;

      suppressClickUntil = performance.now() + 500;

      if (canMove && (distancePassed || velocityPassed)) {
        commitIndex(candidate, true, 'drag');
      } else {
        setTransform(targetOffset(currentIndex), true);
      }

      resetGestureState();
    }

    function startGesture(clientX, clientY, pointerId) {
      measure();
      isDragging = true;
      axis = null;
      startX = clientX;
      startY = clientY;
      startTime = performance.now();
      lastX = clientX;
      lastTime = startTime;
      deltaX = 0;
      deltaY = 0;
      velocityX = 0;
      activePointerId = pointerId == null ? null : pointerId;
      track.style.transition = 'none';
    }

    function moveGesture(clientX, clientY, pointerEvent) {
      if (!isDragging) return;

      var now = performance.now();
      deltaX = clientX - startX;
      deltaY = clientY - startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      if (!axis && Math.max(absX, absY) >= AXIS_LOCK_DISTANCE) {
        if (absX > absY * HORIZONTAL_RATIO) {
          axis = 'x';
          stage.classList.add('is-dragging');

          if (pointerEvent && activePointerId != null && stage.setPointerCapture) {
            try { stage.setPointerCapture(activePointerId); } catch (error) { /* noop */ }
          }
        } else if (absY > absX * HORIZONTAL_RATIO) {
          axis = 'y';
        }
      }

      if (axis !== 'x') return;

      var elapsed = Math.max(1, now - lastTime);
      velocityX = (clientX - lastX) / elapsed;
      lastX = clientX;
      lastTime = now;

      var effectiveDelta = deltaX;
      var atStart = currentIndex === 0 && deltaX > 0;
      var atEnd = currentIndex === items.length - 1 && deltaX < 0;
      if (atStart || atEnd) effectiveDelta *= EDGE_RESISTANCE;

      setTransform(targetOffset(currentIndex) + effectiveDelta, false);
    }

    stage.addEventListener('click', function (event) {
      if (performance.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        suppressClickUntil = 0;
      }
    }, { capture: true, signal: signal });

    if ('PointerEvent' in window) {
      stage.addEventListener('pointerdown', function (event) {
        if (!mobileMedia.matches || event.pointerType === 'mouse') return;
        if (event.button !== undefined && event.button !== 0) return;
        if (event.target.closest('video, model-viewer, iframe, button, a, input, select, textarea')) return;
        startGesture(event.clientX, event.clientY, event.pointerId);
      }, { passive: true, signal: signal });

      stage.addEventListener('pointermove', function (event) {
        if (!isDragging || event.pointerId !== activePointerId) return;
        moveGesture(event.clientX, event.clientY, event);
      }, { passive: true, signal: signal });

      /* Capture-Phase ist absichtlich gewählt, damit ein eventuell noch
         installierter einfacher Swipe-Patch nicht zusätzlich reagiert. */
      stage.addEventListener('pointerup', function (event) {
        if (!isDragging || event.pointerId !== activePointerId) return;
        finishGesture(event.clientX, event.clientY, event);
        if (stage.releasePointerCapture) {
          try { stage.releasePointerCapture(event.pointerId); } catch (error) { /* noop */ }
        }
      }, { capture: true, passive: true, signal: signal });

      stage.addEventListener('pointercancel', function () {
        if (axis === 'x') snapBack();
        else resetGestureState();
      }, { passive: true, signal: signal });
    } else {
      stage.addEventListener('touchstart', function (event) {
        if (!mobileMedia.matches || event.touches.length !== 1) return;
        if (event.target.closest('video, model-viewer, iframe, button, a, input, select, textarea')) return;
        var touch = event.touches[0];
        startGesture(touch.clientX, touch.clientY, null);
      }, { passive: true, signal: signal });

      stage.addEventListener('touchmove', function (event) {
        if (!isDragging || event.touches.length !== 1) return;
        var touch = event.touches[0];
        moveGesture(touch.clientX, touch.clientY, null);
      }, { passive: true, signal: signal });

      stage.addEventListener('touchend', function (event) {
        if (!isDragging || event.changedTouches.length !== 1) return;
        var touch = event.changedTouches[0];
        finishGesture(touch.clientX, touch.clientY, event);
      }, { capture: true, passive: true, signal: signal });

      stage.addEventListener('touchcancel', function () {
        if (axis === 'x') snapBack();
        else resetGestureState();
      }, { passive: true, signal: signal });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        if (internalThumbChange) return;

        /* Die bestehende Theme-Logik darf zuerst laufen. Anschließend werden
           alle Slides wieder in den Track eingehängt und synchronisiert. */
        window.requestAnimationFrame(function () {
          keepAllSlidesMounted();
          commitIndex(index, true, 'thumbnail');
        });
      }, { signal: signal });
    });

    function handleResize() {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = 0;
        measure();
        setTransform(targetOffset(currentIndex), false);
      });
    }

    window.addEventListener('resize', handleResize, { passive: true, signal: signal });
    window.addEventListener('orientationchange', handleResize, { passive: true, signal: signal });

    measure();
    keepAllSlidesMounted();
    updateAccessibility(currentIndex);
    updateThumbnails(currentIndex);
    setTransform(targetOffset(currentIndex), false);
    centerThumbnail(currentIndex, false);
    preloadNeighbours(currentIndex);

    var instance = {
      destroy: function () {
        controller.abort();
        if (resizeFrame) cancelAnimationFrame(resizeFrame);

        items.forEach(function (item, index) {
          item.classList.remove('mobile-gallery-slide');
          item.hidden = index !== currentIndex;
          item.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true');
          if ('inert' in item) item.inert = false;
          stage.appendChild(item);
        });

        track.remove();
        stage.classList.remove('is-mobile-drag-carousel', 'is-dragging');
        stage.style.removeProperty('touch-action');
        delete gallery.dataset.mobileDragCarouselReady;
        instances.delete(gallery);
      }
    };

    instances.set(gallery, instance);
    return instance;
  }

  function syncGallery(gallery) {
    var instance = instances.get(gallery);

    if (mobileMedia.matches) {
      if (!instance) createCarousel(gallery);
    } else if (instance) {
      instance.destroy();
    }
  }

  function init(root) {
    getGalleries(root || document).forEach(syncGallery);
  }

  function syncAll() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', syncAll);
  } else if (mobileMedia.addListener) {
    mobileMedia.addListener(syncAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    getGalleries(event.target).forEach(function (gallery) {
      var instance = instances.get(gallery);
      if (instance) instance.destroy();
    });
  });
})();

/* ======================================================================
   S&F HANDEL – Empfehlungen + mobiler Galerie-Zähler
   ====================================================================== */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var mobileMedia = window.matchMedia(MOBILE_QUERY);

  function asArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  async function fetchRecommendationCards(productId, intent) {
    var url = rootUrl() + 'recommendations/products?section_id=product-recommendation-items&product_id=' +
      encodeURIComponent(productId) + '&limit=10&intent=' + encodeURIComponent(intent);

    try {
      var response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return [];
      var html = await response.text();
      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      return asArray(documentFragment.querySelectorAll('[data-recommendation-product-id]'));
    } catch (error) {
      return [];
    }
  }

  async function initRecommendations(loader) {
    if (!loader || loader.dataset.recommendationsReady === 'true') return;
    loader.dataset.recommendationsReady = 'loading';

    var productId = loader.dataset.productId;
    var target = loader.querySelector('[data-product-recommendations-target]');
    var limit = parseInt(loader.dataset.limit || '4', 10);
    var minimum = parseInt(loader.dataset.minimum || '2', 10);
    if (!productId || !target) {
      loader.remove();
      return;
    }

    var results = await Promise.all([
      fetchRecommendationCards(productId, 'complementary'),
      fetchRecommendationCards(productId, 'related')
    ]);

    var unique = new Set();
    var selected = [];
    results.forEach(function (cards) {
      cards.forEach(function (wrapper) {
        var id = wrapper.getAttribute('data-recommendation-product-id');
        var card = wrapper.querySelector('.product-card');
        if (!id || !card || unique.has(id) || selected.length >= limit) return;
        unique.add(id);
        selected.push(card);
      });
    });

    if (selected.length < minimum) {
      loader.remove();
      return;
    }

    selected.forEach(function (card) {
      target.appendChild(card);
    });

    if (loader.dataset.productAvailable === 'false') {
      var mainGrid = document.querySelector('[data-product-section] .product-main__grid--cro');
      if (mainGrid && mainGrid.parentNode) mainGrid.insertAdjacentElement('afterend', loader);
    }

    loader.hidden = false;
    loader.dataset.recommendationsReady = 'true';
  }

  function getActiveGalleryIndex(gallery, buttons) {
    var activeIndex = buttons.findIndex(function (button) {
      return button.classList.contains('is-active') || button.getAttribute('aria-current') === 'true';
    });
    if (activeIndex >= 0) return activeIndex;

    var activeItem = gallery.querySelector('.product-gallery__item.is-active');
    if (activeItem) {
      var itemId = activeItem.id;
      var matchedIndex = buttons.findIndex(function (button) {
        return button.dataset.galleryTarget === itemId;
      });
      if (matchedIndex >= 0) return matchedIndex;
    }
    return 0;
  }

  function initGalleryCounter(gallery) {
    if (!gallery || gallery.dataset.galleryCounterReady === 'true') return;
    var stage = gallery.querySelector('.product-gallery__stage');
    var buttons = asArray(gallery.querySelectorAll('[data-gallery-target]'));
    if (!stage || buttons.length <= 1) return;

    var counter = document.createElement('span');
    counter.className = 'mobile-gallery-counter';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    stage.appendChild(counter);

    function update(index) {
      var safeIndex = typeof index === 'number' ? index : getActiveGalleryIndex(gallery, buttons);
      safeIndex = Math.max(0, Math.min(buttons.length - 1, safeIndex));
      counter.textContent = (safeIndex + 1) + ' / ' + buttons.length;
      counter.setAttribute('aria-label', 'Produktbild ' + (safeIndex + 1) + ' von ' + buttons.length);
    }

    gallery.addEventListener('product-gallery:change', function (event) {
      if (event.detail && typeof event.detail.index === 'number') update(event.detail.index);
    });

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        window.requestAnimationFrame(function () { update(index); });
      });
    });

    var observer = new MutationObserver(function () { update(); });
    buttons.forEach(function (button) {
      observer.observe(button, { attributes: true, attributeFilter: ['class', 'aria-current'] });
    });

    update();
    gallery.dataset.galleryCounterReady = 'true';
  }

  function initialize(root) {
    var context = root && root.querySelectorAll ? root : document;
    context.querySelectorAll('[data-product-recommendations-loader]').forEach(initRecommendations);
    context.querySelectorAll('[data-product-gallery]').forEach(initGalleryCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initialize(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* ======================================================================
   ENDE – S&F Empfehlungen + mobiler Galerie-Zähler
   ====================================================================== */
